import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceService } from '../services/auth-service.service';
import { UserRoles } from '../enums/userRoles.enum';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  constructor(public auth: AuthServiceService, public router: Router) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // this.auth.isAuthenticated() && ((localStorage.getItem('role') === 'Admin') || localStorage.getItem('role') === 'SuperAdmin')
    if (this.auth.isAuthenticated() && ((this.auth.getRole().indexOf('CaseStudies.Admin')>=0) || this.auth.getRole().indexOf('CaseStudies.SuperAdmin'))) {
      return true;
    } else {
      this.router.navigate(['/unauthorized']);
    }
  }

}
